<template>
  <v-navigation-drawer
    app
    class="app-drawer"
    :mini-variant.sync="mini"
    v-model="drawer"
    :width="drawerWidth"
    :dark="$vuetify.dark"
  >
    <v-toolbar color="primary darken-1" dark>
      <v-toolbar-title>
        <v-select
          :items="projectItems"
          v-model="project"
          item-text="showName"
          item-value="id"
          :menu-props="{ auto: true, contentClass: 'project-select-menu' }"
          outlined
          return-object
          hide-details
          @change="selectProject"
        >
          <template v-slot:selection="{ item }">
            <span
              style="
                width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                line-height: 1.2;
              "
            >
              {{ item.showName }}
            </span>
          </template>
        </v-select>
      </v-toolbar-title>
    </v-toolbar>
    <div class="app-drawer__inner">
      <v-list :dense="drawerWidth !== 64" class="pa-0" expand>
        <template v-for="(item, key) in navItems">
          <template v-if="item.children && item.children.length > 0">
            <v-list-group
              :key="key"
              no-action
              :to="item.path"
              v-model="item.active"
            >
              <template v-slot:prependIcon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" v-text="item.meta.icon" />
                  </template>
                  <span>
                    {{ item.meta.title }}
                  </span>
                </v-tooltip>
              </template>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="item.meta.title" />
                </v-list-item-content>
              </template>
              <v-list-item
                :class="drawerWidth === 64 ? 'pl-4' : ''"
                v-for="subItem in item.children"
                :key="subItem.name"
                :to="subItem.path"
                v-show="!subItem.meta.hiddenInMenu"
              >
                <template v-if="drawerWidth === 64">
                  <v-list-item-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          v-text="subItem.meta.icon"
                        />
                      </template>
                      <span>{{ subItem.meta.title }}</span>
                    </v-tooltip>
                  </v-list-item-icon>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.meta.title" />
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-item
              :key="key"
              :to="item.path"
              v-show="!item.meta.hiddenInMenu"
            >
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" v-text="item.meta.icon" />
                  </template>
                  <span>{{ item.meta.title }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content v-if="drawerWidth !== 64">
                <v-list-item-title v-text="item.meta.title" />
              </v-list-item-content>
              <v-list-item-action v-if="item.meta.new">
                <v-icon color="green">mdi-new-box </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { protectedRoute as routes } from "@/router/config";
import { httpPost } from "@/util/request";
import store from "@/store";
import { AUTH_TYPE } from "@/util/utils";

export default {
  components: {},
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mini: false,
      drawerWidth: 256,
      drawer: true,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
      project: null,
      projectItems: [],
      navItems: [],
    };
  },

  computed: {
    computeLogo() {
      return "/static/m.png";
    },
  },
  mounted() {
    this.navItems = routes[0].children.filter((a) => {
      //页面展示验证权限，默认是最低2,
      let auth = a.meta.auth;
      if (auth == null) {
        auth = AUTH_TYPE.PRODUCT;
      }
      return store.getters.getUser && store.getters.getUser.auth <= auth;
    });
    this.getProjectsFromServer(() => {
      let project = store.getters.getProject;
      if (project) {
        for (let projectItem of this.projectItems) {
          if (projectItem.id === project) {
            // 如果已选的项目和有权限的项目相符，就用这个。否则就走下面的逻辑，默认选列表第一个项目
            this.project = projectItem;
            return;
          }
        }
      }
      this.selectProject(this.projectItems[0]);
    });
    this.updateActiveListGroup(this.$route.path);
  },

  watch: {
    "$route.path": {
      immediate: true,
      handler(newPath) {
        this.updateActiveListGroup(newPath);
      },
    },
  },

  methods: {
    updateActiveListGroup(path) {
      // 重置所有列表组的激活状态
      this.navItems.forEach((item) => {
        this.$set(item, "active", false);
        // 检查当前路由是否属于该列表组的子项
        if (
          item.children &&
          item.children.some((subItem) => subItem.path === path)
        ) {
          this.$set(item, "active", true);
        }
      });
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    selectProject(projectItem) {
      this.project = projectItem;
      this.$store.commit("setProject", projectItem.id);
      this.$store.commit("setProjectName", projectItem.projectName);
      this.$store.commit("setShowName", projectItem.showName);
      this.$emit("projectChange", projectItem);
    },
    getProjectsFromServer(callback) {
      this.loading = true;
      httpPost("/auth/getAuthProjects")
        .then((resp) => {
          if (resp) {
            this.projectItems = resp;
          }
          if (callback && typeof callback === "function") {
            callback();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.app-drawer
  overflow: hidden !important

  &__inner
    height: calc(100vh - 100px)

  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
</style>

<!-- 非 scoped：菜单内容被 teleport 到 [data-app] 下，scoped 选不到 -->
<style>
/* auto 模式下 Vuetify 把菜单高度写死成 200px（VMenu.calculatedMaxHeight），
   传入的 maxHeight 会被忽略；且它是内联样式，得用 !important 才能覆盖 */
.project-select-menu {
  max-height: 304px !important;
}
</style>
